module.exports = __webpack_public_path__ + "static/media/errorPage.68b1cecd.jpg";